import Axios from "axios";


export const shifts = {
  namespaced: true,
  state: {
    shifts: null,
    userShifts: null,
    singleShift: null,
    salaries: null,
    singleSalary: null,
    periodStart: '26.05.2021',
    activeShifts: null,
    monthSalaries: null,
  },
  actions: {
    async addNewShift(context, payload) {
      let userToken = JSON.parse(localStorage.getItem("user"));
      let options = {
        headers: { Authorization: `Bearer ${userToken.jwt}` },
      };
        const response = await Axios.post(
          "https://api.rightcloud.pl/renty-shifts",
          payload,
          options
        );
        const responseData = await response;
        if (responseData.status !== 200) {
          const error = new Error(
            responseData.message ||
              "Failed to add new shift. Please try again later."
          );
          throw error;
        } 
            // adding next shift
    },
    async fetchSingleSalary(context, payload){
      let userToken = JSON.parse(localStorage.getItem("user"));
      let options = {
        headers: { Authorization: `Bearer ${userToken.jwt}` },
      };
      const response = await Axios.get(
        `https://api.rightcloud.pl/splendid-wyplaties/${payload}`,
        options
      );
      const responseData = await response;
      context.commit('setSingleSalary', responseData.data)
    },
    async getSalaries(context, payload){
      let userToken = JSON.parse(localStorage.getItem("user"));
      let options = {
        headers: { Authorization: `Bearer ${userToken.jwt}` },
      };
      const response = await Axios.get(`https://api.rightcloud.pl/splendid-wyplaties/count?isNewShift=true`, options)
      const responseData = await response;
      if(responseData.status !== 200){
        console.log('Error while fetching')
      } else {
        context.commit('setSalaries', responseData.data)
      }
    },
    async getSalariesMonth(context, payload){
      let userToken = JSON.parse(localStorage.getItem("user"));
      let options = {
        headers: { Authorization: `Bearer ${userToken.jwt}` },
      };
      const response = await Axios.get(`https://api.rightcloud.pl/splendid-wyplaties/?month=${payload.month}`, options)
      const responseData = await response;
      if(responseData.status !== 200){
        console.log('Error while fetching')
      } else {
        context.commit('setSalariesMonth', responseData.data)
      }
    },
    async fetchSingle(context, payload){
      let userToken = JSON.parse(localStorage.getItem("user"));
      let options = {
        headers: { Authorization: `Bearer ${userToken.jwt}` },
      };
      const response = await Axios.get(
        `https://api.rightcloud.pl/renty-shifts/${payload}`,
        options
      );
      const responseData = await response;
      context.commit('setSingle', responseData.data)

    },
    async makeUnactive(context, payload){
      let userToken = JSON.parse(localStorage.getItem("user"));
      let options = {
        headers: { Authorization: `Bearer ${userToken.jwt}` },
      };
      const response = await Axios.put(
        `https://api.rightcloud.pl/splendid-wyplaties/${payload}`, {isNewShift: false},
        options
      );
      const responseData = await response;
      context.commit('removeSalary', payload)

    },
    async fetchShifts(context) {
      let userToken = JSON.parse(localStorage.getItem("user"));
      let options = {
        headers: { Authorization: `Bearer ${userToken.jwt}` },
      };
      const response = await Axios.get(
        "https://api.rightcloud.pl/renty-shifts",
        options
      );
      const responseData = await response;
      context.commit("setShifts", responseData.data);
    },
    async fetchActive(context){
      let userToken = JSON.parse(localStorage.getItem('user'));
      let options = {
        headers: { Authorization: `Bearer ${userToken.jwt}` },
      };
      const response = await Axios.get(
        "https://api.rightcloud.pl/renty-shifts?active=true",
        options
      );
      const responseData = await response;
      context.commit("setActive", responseData.data)
    },
    async updateShift(context, {data, param}) {
      let userToken = JSON.parse(localStorage.getItem("user"));
      let options = {
        headers: { Authorization: `Bearer ${userToken.jwt}` },
      };
      const response = await Axios.put(
        `https://api.rightcloud.pl/renty-shifts/${param}`,
        data,
        options
      );
      const responseData = await response;
      const addMileage = await Axios.put(`https://api.rightcloud.pl/renty-cars/${data.selectedCar}`, {mileage: data.endMileage}, options)
      const mileageResponse = await addMileage;
      context.commit("setSingle", responseData.data);
    },

  },
  mutations: {
    setShifts(state, payload) {
      state.shifts = payload;
    },
    setSingle(state, payload){
      state.singleShift = payload
    },
    setSalaries(state, payload){
      state.salaries = payload
    },
    setSingleSalary(state, payload) {
      state.singleSalary = payload
    },
    removeSalary(state, payload){
      let index = state.salaries.findIndex(item => item.id == payload)
      state.salaries.splice(index, 1)
    },
    setActive(state, payload){
      state.activeShifts = payload
    },
    setSalariesMonth(state,payload){
      state.monthSalaries = payload
    }

  },
  getters: {
    getActive(state) {
      if(state.shifts){
        return state.shifts.filter((item) => item.active );
      }
    },
    getDone(state) {
      if(state.shifts){
        return state.shifts.filter((item) => !item.active );
      }
    },
    getNewSalaryEntry(state){
      if(state.salaries){
        return state.salaries}
    },
    getSingle(state){
      return state.singleShift
    },
    getSingleSalary(state){
      return state.singleSalary
    },
    getAllShifts(state){
      return state.shifts
    },
    monthSalaries(state){
      return state.monthSalaries
    },
    totalMonth(state){
      const currentMonth = new Date()
      const monthNumber = currentMonth.getMonth()
      const totalMonth = state.shifts.filter((item) => !item.active );
      let totalEarning = 0
      for(let shift in totalMonth){
        let date = totalMonth[shift].date
        let makeDate = new Date(date)
        let month = makeDate.getMonth()
        if(month === monthNumber){
          totalEarning += totalMonth[shift].earning + totalMonth[shift].money
        }
      }
      return totalEarning
    },
    getWeeks(state){
      const year = state.singleSalary.periodStart.slice(0,4)
      const month = state.singleSalary.periodStart.slice(4,-2)
      const day = state.singleSalary.periodStart.slice(-2)
      const startingPeriod = new Date(year,month - 1,day)
      const startPeriodEnd = new Date(startingPeriod.getFullYear(), startingPeriod.getMonth(), startingPeriod.getDate() +6)
      const secondPeriod = new Date(startingPeriod.getFullYear(), startingPeriod.getMonth(), startingPeriod.getDate() +7)
      const secondPeriodEnd = new Date(startingPeriod.getFullYear(), startingPeriod.getMonth(), startingPeriod.getDate() +13)
      const thirdPeriod = new Date(startingPeriod.getFullYear(), startingPeriod.getMonth(), startingPeriod.getDate() + 14)
      const thirdPeriodEnd = new Date(startingPeriod.getFullYear(), startingPeriod.getMonth(), startingPeriod.getDate() + 20)
      const fourthPeriod = new Date(startingPeriod.getFullYear(), startingPeriod.getMonth(), startingPeriod.getDate() +21)
      const fourthPeriodEnd = new Date(startingPeriod.getFullYear(), startingPeriod.getMonth(), startingPeriod.getDate() +27)
      const fivePeriod = new Date(startingPeriod.getFullYear(), startingPeriod.getMonth(), startingPeriod.getDate() +28)
      const fivePeriodEnd = new Date(startingPeriod.getFullYear(), startingPeriod.getMonth(), startingPeriod.getDate() +34)
      return {period1: {start: startingPeriod, end: startPeriodEnd}, period2: {start: secondPeriod,end: secondPeriodEnd}, period3: {start: thirdPeriod, end: thirdPeriodEnd}, period4: {start:fourthPeriod, end: fourthPeriodEnd}, period5: {start:fivePeriod, end: fivePeriodEnd}}
    }
  },
};
